<!-- Container -->
<mat-card class="collapsible-container p-0">
    <div>
        <!-- Header -->
        <div class="tw-flex tw-justify-start tw-items-center tw-py-3"
            [ngClass]="{ 'tw-border-b tw-border-gray-300' : expanded }">
            <div class="tw-flex tw-justify-start tw-items-center" (click)="toggleExpanded()">
                <div class="tw-ml-3">
                    <mat-icon
                      class="tw-cursor-pointer"
                      *ngIf="!disableToggle">
                      {{ expanded ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                </div>
                <div class="tw-px-3">
                    <ng-content select="[bannerLeft]"></ng-content>
                </div>
            </div>
            <div class="tw-ml-auto tw-mr-3">
                <ng-content select="[bannerRight]"></ng-content>
            </div>
        </div>
        <!-- /Header -->
        <!-- Content -->
        <div [@openClose]="expanded ? 'open' : 'closed'">
            <div class="card-content tw-px-4">
                <ng-content select="[mainContent]"></ng-content>
            </div>
        </div>
        <!-- /Content -->
    </div>
    <ng-content select="[sibling]"></ng-content>

</mat-card>
<!-- /Container -->
